import { colors } from '@material-ui/core'
import {
  CheckCircle as CheckCircleIcon,
  AlertTriangle as AlertFailedIcon,
  Loader as LoaderIcon,
} from 'react-feather'

import theme from 'theme'
import language from './language'

// BANNER CUSTOMIZATION CARD
const COLOR_CUSTOMIZATION_CARD_ID = 1
const LOGO_CUSTOMIZATION_CARD_ID = 2
const DESCRIPTION_CUSTOMIZATION_CARD_ID = 3
const POSITION_CUSTOMIZATION_CARD_ID = 4
const PRIVACY_PORTAL_CUSTOMIZATION_CARD_ID = 5
const TEXT_CUSTOMIZATION_CARD_ID = 6
const TEXT_CUSTOMIZATION_LEVEL_2_CARD_ID = 7
const FONT_CUSTOMIZATION_CARD_ID = 8

const ACTIVE_STATUS_ID = 'active'
const INCOMPLETE_STATUS_ID = 'incomplete'
const INACTIVE_STATUS_ID = 'inactive'

const MANUAL_KIND = 'manual'
const AUTOMATIC_KIND = 'automatic'

// STATUS DE SCANNER LOG
const COMPLETED_SCANNER_STATUS_ID = 'succeded'
const INITIATED_SCANNER_STATUS_ID = 'initiated'
const FAILED_SCANNER_STATUS_ID = 'failed'

// BANNER CUSTOMIZATION POSITION
const BANNER_LEFT_POSITION = 'left'
const BANNER_RIGHT_POSITION = 'right'
const BANNER_CENTER_POSITION = 'center'
const BANNER_FIXED_POSITION = 'fixed'

const DEFAULT_DESCRIPTION_BR =
  'Para melhorar a sua experiência na plataforma e prover serviços personalizados, utilizamos cookies. Ao aceitar, você terá acesso a todas as funcionalidades do site. Se clicar em "Rejeitar", os cookies que não forem estritamente necessários serão desativados. Para escolher quais quer autorizar, clique em "Gerenciar cookies".'

const DEFAULT_DESCRIPTION_EN =
  'To enhance your experience on the platform and provide personalized services, we use cookies. By accepting, you will have access to all site features. If you click "Reject all", non-essential cookies will be disabled. To choose which ones to authorize, click "Manage cookies".'

const DEFAULT_DESCRIPTION_ES =
  'Para mejorar su experiencia en la plataforma y brindar servicios personalizados, utilizamos cookies. Al aceptar, tendrá acceso a todas las funcionalidades del sitio. Si hace clic en "Rechazar todos", las cookies que no sean estrictamente necesarias serán desactivadas. Para elegir cuáles autorizar, haga clic en "Gestionar cookies".'

// BANNER CONFIGURATION STEPS
const BANNER_CONFIGURATION = 'Configurações Básicas'
const BANNER_APPEARANCE = 'Aparência'
const BANNER_LAYOUT = 'Layout do Banner'
const AGE_GATE = 'Controle de Idade'
const COOKIE_SCANNER = 'Escaneamento de Cookies'
const COOKIE_CLASSIFICATION = 'Categorização de Cookies'
const BANNER_INSTALLATION = 'Código de Instalação'
const COOKIES_POLICY = 'Política de Cookies'

const BANNER_CONFIGURATION_STEP = 0
const BANNER_APPEARANCE_STEP = 1
const BANNER_LAYOUT_STEP = 2
const AGE_GATE_STEP = 3
const COOKIE_SCANNER_STEP = 4
const COOKIE_CLASSIFICATION_STEP = 5
const BANNER_INSTALLATION_STEP = 6
const COOKIES_POLICY_STEP = 7

const BUTTON_TEXTS = {
  [BANNER_CONFIGURATION_STEP]: 'Salvar e Continuar',
  [BANNER_APPEARANCE_STEP]: 'Salvar e Continuar',
  [BANNER_LAYOUT_STEP]: 'Salvar e Continuar',
  [AGE_GATE_STEP]: 'Salvar e Continuar',
  [COOKIE_SCANNER_STEP]: 'Continuar',
  [COOKIE_CLASSIFICATION_STEP]: 'Salvar e Continuar',
  [BANNER_INSTALLATION_STEP]: {
    COMPILE: 'Gerar código',
    COMPILING: 'Gerando...',
    CONTINUE: 'Continuar',
  },
  DEFAULT: 'Próximo',
}

const SUCCESS_MESSAGES = {
  [BANNER_CONFIGURATION_STEP]: 'Configurações básicas salvas com sucesso!',
  [BANNER_APPEARANCE_STEP]: 'Aparência salva com sucesso!',
  [BANNER_LAYOUT_STEP]: 'Layout do banner salvo com sucesso!',
  [AGE_GATE_STEP]: 'Controle de idade salvo com sucesso!',
  [COOKIE_SCANNER_STEP]: 'Escaneamento de cookies executado com sucesso!',
  [COOKIE_CLASSIFICATION_STEP]: 'Categorização de cookies salva com sucesso!',
  [BANNER_INSTALLATION_STEP]: 'Código de instalação gerado com sucesso!',
}

const STEPS = {
  CONFIGURATION: BANNER_CONFIGURATION_STEP,
  APPEARANCE: BANNER_APPEARANCE_STEP,
  BANNER_LAYOUT: BANNER_LAYOUT_STEP,
  AGE_GATE: AGE_GATE_STEP,
  SCANNER: COOKIE_SCANNER_STEP,
  CLASSIFICATION: COOKIE_CLASSIFICATION_STEP,
  INSTALLATION: BANNER_INSTALLATION_STEP,
  COOKIE_POLICY: COOKIES_POLICY_STEP,
}

const ALERTS = {
  CACHE: {
    key: 'cache',
    severity: 'info',
    title: 'Atenção:',
    message:
      'Suas alterações serão aplicadas em até 60 minutos devido ao cache do servidor. Agradecemos a compreensão!',
  },
  COMPILATION: {
    key: 'compile',
    severity: 'warning',
    title: '',
    message:
      'Seu banner está sendo gerado e ficará disponível em até 5 minutos. Agradecemos a compreensão!',
    actionLabel: 'Atualizar Status',
    refreshAction: true,
  },
  CLASSIFICATION: {
    key: 'classification',
    severity: 'info',
    title: 'Atenção:',
    message:
      'Nosso sistema classificará seus cookies e caso você tenha cookies não classificados recomendamos que classifique-os.',
  },
  BUILD_FAILED: {
    key: 'build_failed',
    severity: 'error',
    title: 'Erro:',
    message: 'Falha na geração do banner. Por favor, tente novamente.',
    actionLabel: 'Ir para Instalação',
    actionStep: STEPS.INSTALLATION,
  },
  SCANNER_FAILED: {
    key: 'scanner_failed',
    severity: 'error',
    title: 'Erro:',
    message: 'Falha no escaneamento de cookies. Por favor, tente novamente.',
    actionLabel: 'Ir para Escaneamento de Cookies',
    actionStep: STEPS.SCANNER,
  },
  AUTOSCANNER: {
    key: 'autoscanner',
    severity: 'info',
    title: 'Atenção:',
    message:
      'Nosso sistema fará o escaneamento automático de cookies mensalmente, você pode clicar em "Escanear" caso queira realizar o escaneamento manual.',
  },
  AUTOCOMPILATION: {
    key: 'autocompilation',
    severity: 'info',
    title: 'Atenção:',
    message:
      'Nosso sistema fará a atualização do código do banner mensalmente, você pode clicar em "Gerar código" caso queira atualizar manualmente.',
  },
  SCANNER: {
    key: 'scanner',
    severity: 'warning',
    title: '',
    message:
      'Seu site está sendo escaneado e ficará pronto em até 5 minutos. Agradecemos a compreensão!',
    actionLabel: 'Verificar status',
    refreshAction: true,
  },
  CONFIGURATION: {
    key: 'configuration',
    severity: 'info',
    title: 'Atenção:',
    message:
      'Ao atualizar a URL do seu site uma varredura automática será iniciada para você, lembre-se de verificar o status do seu banner ao final desse processo.',
  },
  COOKIE_POLICY: {
    key: 'cookie_policy',
    severity: 'info',
    title: 'Atenção:',
    message:
      'Aqui você tem a opção de visualizar, criar ou atualizar sua política de cookies. Caso queira editar ou adicionar no canal de atendimento ao titular de dados clique em "Editar política"',
    actionLabel: 'Editar política',
    actionType: 'edit_policy',
  },
  AGE_GATE: {
    key: 'age_gate',
    severity: 'info',
    title: 'Atenção:',
    message:
      'Os cookies de todos os menores de idade precisam ser barrados. Verificar na Lei o Artigo.',
  },
  AGE_GATE_COMPILATION: {
    key: 'age_gate_compilation',
    severity: 'warning',
    title: '',
    message:
      'O Age Gate está sendo compilado e ficará disponível em até 5 minutos. Agradecemos a compreensão!',
    actionLabel: 'Atualizar Status',
    refreshAction: true,
  },
  AGE_GATE_BUILD_FAILED: {
    key: 'age_gate_build_failed',
    severity: 'error',
    title: 'Erro:',
    message: 'Falha na geração do Age Gate. Por favor, tente novamente.',
    actionLabel: 'Ir para Age Gate',
    actionStep: STEPS.AGE_GATE,
  },
}

const BANNER_CONFIGURATION_STEPS = [
  {
    title: BANNER_CONFIGURATION,
    step: BANNER_CONFIGURATION,
    buttonId: 'id-banner-configuration',
  },
  {
    title: BANNER_APPEARANCE,
    step: BANNER_APPEARANCE,
    buttonId: 'id-banner-appearance',
  },
  {
    title: BANNER_LAYOUT,
    step: BANNER_LAYOUT,
    buttonId: 'id-banner-layout',
  },
  {
    title: AGE_GATE,
    step: AGE_GATE,
    buttonId: 'id-age-control',
  },
  {
    title: COOKIE_SCANNER,
    step: COOKIE_SCANNER,
    buttonId: 'id-cookie-scanner',
  },
  {
    title: COOKIE_CLASSIFICATION,
    step: COOKIE_CLASSIFICATION,
    buttonId: 'id-cookie-classification',
  },
  {
    title: BANNER_INSTALLATION,
    step: BANNER_INSTALLATION,
    buttonId: 'id-banner-compilation',
  },
  {
    title: COOKIES_POLICY,
    step: COOKIES_POLICY,
    buttonId: 'id-cookies-policy',
  },
]

const DEFAULT_DESCRIPTIONS = [
  {
    description: DEFAULT_DESCRIPTION_BR,
    language: {
      code: language.LANGUAGE_CODES.BR,
    },
  },
  {
    description: DEFAULT_DESCRIPTION_EN,
    language: {
      code: language.LANGUAGE_CODES.US,
    },
  },
  {
    description: DEFAULT_DESCRIPTION_ES,
    language: {
      code: language.LANGUAGE_CODES.ES,
    },
  },
]

const SUPPORTED_IMAGE_FILE_SCHEMA_TYPES = ['image/jpeg', 'image/png']

const SUPPORTED_IMAGE_FILE_INPUT_TYPES = '.jpg,.jpeg,.png,'

const LINK_DOCUMENTATION_TAG_MANAGER =
  'https://documentacao-dpo.notion.site/Configurando-o-banner-de-cookies-via-Google-Tag-Manager-67e524030bbd4263b9d6b128e0e56103'

const LINK_DOCUMENTATION_HTML =
  'https://documentacao-dpo.notion.site/Bloqueio-din-mico-de-scripts-scriptBlocker-33ecf66ae9fc800ea6e9eaf6e918941f'

const LINK_DOCUMENTATION_HIDE_ON_ACCEPT =
  'https://documentacao-dpo.notion.site/Configurando-o-acionamento-manual-do-aviso-de-consentimento-banner-173cf66ae9fc8040b149d9e1fe54bb18'

const AGE_VERIFICATION_TAB_ID = 1
const AGE_BLOCKING_TAB_ID = 2

const AGE_GATE_CARD_TABS = [
  { id: AGE_VERIFICATION_TAB_ID, tabName: 'Textos' },
  { id: AGE_BLOCKING_TAB_ID, tabName: 'Bloqueios' },
]

const AGE_GATE_OVERLAY_OPACITY_MARKS = [
  { value: 0, label: '0%' },
  { value: 25, label: '25%' },
  { value: 50, label: '50%' },
  { value: 75, label: '75%' },
  { value: 100, label: '100%' },
]

const CUSTOMIZATION_CARD_TABS = [
  { id: COLOR_CUSTOMIZATION_CARD_ID, tabName: 'Cor' },
  { id: LOGO_CUSTOMIZATION_CARD_ID, tabName: 'Logo' },
  { id: TEXT_CUSTOMIZATION_CARD_ID, tabName: 'Textos (1° nível)' },
  { id: TEXT_CUSTOMIZATION_LEVEL_2_CARD_ID, tabName: 'Textos (2° nível)' },
  { id: FONT_CUSTOMIZATION_CARD_ID, tabName: 'Fonte' },
  { id: POSITION_CUSTOMIZATION_CARD_ID, tabName: 'Posição' },
  {
    id: PRIVACY_PORTAL_CUSTOMIZATION_CARD_ID,
    tabName: 'Canal de Atendimento',
  },
]

const APPEARANCE_CARD_TABS = [
  { id: COLOR_CUSTOMIZATION_CARD_ID, tabName: 'Cor' },
  { id: LOGO_CUSTOMIZATION_CARD_ID, tabName: 'Logo' },
  { id: FONT_CUSTOMIZATION_CARD_ID, tabName: 'Fonte' },
]

const BANNER_LAYOUT_CARD_TABS = [
  { id: TEXT_CUSTOMIZATION_CARD_ID, tabName: 'Textos (1° nível)' },
  { id: TEXT_CUSTOMIZATION_LEVEL_2_CARD_ID, tabName: 'Textos (2° nível)' },
  { id: POSITION_CUSTOMIZATION_CARD_ID, tabName: 'Posição' },
  {
    id: PRIVACY_PORTAL_CUSTOMIZATION_CARD_ID,
    tabName: 'Canal de Atendimento',
  },
]

const STATUS_TRANSLATION = {
  [ACTIVE_STATUS_ID]: 'Ativo',
  [INCOMPLETE_STATUS_ID]: 'Incompleto',
  [INACTIVE_STATUS_ID]: 'Completo',
}

const KIND_TRANSLATION = {
  [MANUAL_KIND]: 'Manual',
  [AUTOMATIC_KIND]: 'Automático',
}

const STATUS_CHIP_COLOR = {
  [ACTIVE_STATUS_ID]: colors.green[100],
  [INCOMPLETE_STATUS_ID]: colors.blue[100],
  [INACTIVE_STATUS_ID]: colors.blueGrey[100],
}

const STATUS_CHIP_FONT_COLOR = {
  [ACTIVE_STATUS_ID]: colors.green[800],
  [INCOMPLETE_STATUS_ID]: colors.blue[800],
  [INACTIVE_STATUS_ID]: colors.blueGrey[800],
}

const SCANNER_STATUS_TRANSLATION = {
  [COMPLETED_SCANNER_STATUS_ID]: 'Completo',
  [FAILED_SCANNER_STATUS_ID]: 'Falha',
  [INITIATED_SCANNER_STATUS_ID]: 'Escaneando',
}

const SCANNER_STATUS_COLOR = {
  [COMPLETED_SCANNER_STATUS_ID]: theme.palette.tertiary.main,
  [FAILED_SCANNER_STATUS_ID]: theme.palette.error.main,
  [INITIATED_SCANNER_STATUS_ID]: theme.palette.primary.main,
}

const SCANNER_STATUS_ICON = {
  [COMPLETED_SCANNER_STATUS_ID]: CheckCircleIcon,
  [FAILED_SCANNER_STATUS_ID]: AlertFailedIcon,
  [INITIATED_SCANNER_STATUS_ID]: LoaderIcon,
}

const COOKIE_CREATION_CARD_ITEMS = [
  {
    label: 'Nome',
    controlName: 'name',
  },
]

const NEW_BANNER_MODAL_CONTROL_ITEMS = [
  {
    label: 'Nome',
    controlName: 'name',
  },
]

const COOKIES_BANNERS_MAIN_DRIVER_STEP = 'cookies-banners-main-driver-step'

const COOKIES_BANNERS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + COOKIES_BANNERS_MAIN_DRIVER_STEP,
    popover: {
      description:
        "Local onde está a listagem dos sites que possuem nosso banner de cookies e onde configurá-lo. Primeiro, clique no botão 'Adicionar Site'. Após o cadastro do site na plataforma, clique nos três pontos e selecione 'Configurar'.",
    },
  },
]

const COOKIES_BANNER_SETTING_DRIVER_STEP_1 =
  'cookies-banner-setting-driver-step-1'
const COOKIES_BANNER_SETTING_DRIVER_STEP_2 =
  'cookies-banner-setting-driver-step-2'
const COOKIES_BANNER_SETTING_DRIVER_STEP_3 =
  'cookies-banner-setting-driver-step-3'
const COOKIES_BANNER_SETTING_DRIVER_STEP_4 =
  'cookies-banner-setting-driver-step-4'
const COOKIES_BANNER_SETTING_DRIVER_STEP_5 =
  'cookies-banner-setting-driver-step-5'
const COOKIES_BANNER_SETTING_DRIVER_STEP_6 =
  'cookies-banner-setting-driver-step-6'
const COOKIES_BANNER_SETTING_DRIVER_STEP_7 =
  'cookies-banner-setting-driver-step-7'
const COOKIES_BANNER_SETTING_DRIVER_STEP_8 =
  'cookies-banner-setting-driver-step-8'
const COOKIES_BANNER_SETTING_DRIVER_STEP_9 =
  'cookies-banner-setting-driver-step-9'

const COOKIES_BANNER_SETTING_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + COOKIES_BANNER_SETTING_DRIVER_STEP_1,
    popover: {
      description:
        'Para a configuração do Banner de cookies, é necessário passar por 8 etapas. Clique nos botões de etapas/navegação para navegar entre as etapas.',
    },
  },
  {
    element: '#id-banner-configuration',
    popover: {
      description:
        'Clique aqui para acessar a configuração do banner. Nesta etapa você define o nome do banner, a URL do site e se os cookies não categorizados são bloqueados automaticamente.',
    },
  },
  {
    element: '#id-banner-appearance',
    popover: {
      description:
        'Clique aqui para personalizar a aparência do banner, alterando cores, logo e fonte.',
    },
  },
  {
    element: '#id-banner-layout',
    popover: {
      description:
        'Clique aqui para configurar o layout do banner, incluindo textos, posição na tela e canal de atendimento.',
    },
  },
  {
    element: '#id-age-control',
    popover: {
      description:
        'Clique aqui para configurar o controle de idade, definindo a idade mínima e as mensagens exibidas ao usuário.',
    },
  },
  {
    element: '#id-cookie-scanner',
    popover: {
      description:
        'Clique aqui para executar um escâner em seu site e identificar automaticamente todos os cookies utilizados.',
    },
  },
  {
    element: '#id-cookie-classification',
    popover: {
      description:
        'Clique aqui para classificar os cookies encontrados de acordo com as categorias da ANPD (necessários, funcionais, analíticos, etc.).',
    },
  },
  {
    element: '#id-banner-compilation',
    popover: {
      description:
        'Clique aqui para gerar o código do banner e prosseguir com  a instalação correta via HTML ou Google Tag Manager.',
    },
  },
  {
    element: '#id-cookies-policy',
    popover: {
      description:
        'Clique aqui para configurar e personalizar a política de cookies que será exibida aos usuários do seu site.',
    },
  },
]

const CUSTOMIZATION_POSITION_RADIO_GROUP_ITEMS = [
  { value: BANNER_LEFT_POSITION, label: 'Canto inferior esquerdo' },
  { value: BANNER_RIGHT_POSITION, label: 'Canto inferior direito' },
  { value: BANNER_CENTER_POSITION, label: 'Inferior central' },
  { value: BANNER_FIXED_POSITION, label: 'Inferior completo' },
]

const PREVIEW_MODES = {
  BANNER: 'banner',
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
}

const DESKTOP_PREVIEW_WIDTH = 1024
const DESKTOP_PREVIEW_HEIGHT = 640
const MOBILE_PREVIEW_WIDTH = 376
const MOBILE_PREVIEW_HEIGHT = 656

const PRIMARY_BANNER_ACTION_BUTTONS = {
  settings: {
    variant: 'text',
    classNameKey: 'settingsButton',
    handlerKey: 'onManageCookies',
    labelKey: 'manage',
  },
  reject: {
    variant: 'outlined',
    classNameKey: 'rejectButton',
    handlerKey: 'handleOpenBanner',
    labelKey: 'reject',
  },
  accept: {
    variant: 'contained',
    color: 'primary',
    classNameKey: 'acceptButton',
    handlerKey: 'handleOpenBanner',
    labelKey: 'accept',
  },
}

const banners = {
  AGE_BLOCKING_TAB_ID,
  AGE_GATE_CARD_TABS,
  AGE_GATE_OVERLAY_OPACITY_MARKS,
  AGE_GATE_STEP,
  AGE_GATE,
  AGE_VERIFICATION_TAB_ID,
  ALERTS,
  APPEARANCE_CARD_TABS,
  BANNER_APPEARANCE_STEP,
  BANNER_APPEARANCE,
  BANNER_CENTER_POSITION,
  BANNER_CONFIGURATION_STEP,
  BANNER_CONFIGURATION_STEPS,
  BANNER_CONFIGURATION,
  BANNER_FIXED_POSITION,
  BANNER_INSTALLATION_STEP,
  BANNER_INSTALLATION,
  BANNER_LAYOUT_CARD_TABS,
  BANNER_LAYOUT_STEP,
  BANNER_LAYOUT,
  BANNER_LEFT_POSITION,
  BANNER_RIGHT_POSITION,
  BUTTON_TEXTS,
  COLOR_CUSTOMIZATION_CARD_ID,
  COMPLETED_SCANNER_STATUS_ID,
  COOKIE_CLASSIFICATION_STEP,
  COOKIE_CLASSIFICATION,
  COOKIE_CREATION_CARD_ITEMS,
  COOKIE_SCANNER_STEP,
  COOKIE_SCANNER,
  COOKIES_BANNER_SETTING_DRIVER_STEP_1,
  COOKIES_BANNER_SETTING_DRIVER_STEP_2,
  COOKIES_BANNER_SETTING_DRIVER_STEP_3,
  COOKIES_BANNER_SETTING_DRIVER_STEP_4,
  COOKIES_BANNER_SETTING_DRIVER_STEP_5,
  COOKIES_BANNER_SETTING_DRIVER_STEP_6,
  COOKIES_BANNER_SETTING_DRIVER_STEP_7,
  COOKIES_BANNER_SETTING_DRIVER_STEP_8,
  COOKIES_BANNER_SETTING_DRIVER_STEP_9,
  COOKIES_BANNER_SETTING_DRIVER_STEPS_OBJECT,
  COOKIES_BANNERS_DRIVER_STEPS_OBJECT,
  COOKIES_BANNERS_MAIN_DRIVER_STEP,
  COOKIES_POLICY_STEP,
  COOKIES_POLICY,
  CUSTOMIZATION_CARD_TABS,
  CUSTOMIZATION_POSITION_RADIO_GROUP_ITEMS,
  DEFAULT_DESCRIPTIONS,
  DESCRIPTION_CUSTOMIZATION_CARD_ID,
  DESKTOP_PREVIEW_HEIGHT,
  DESKTOP_PREVIEW_WIDTH,
  FAILED_SCANNER_STATUS_ID,
  FONT_CUSTOMIZATION_CARD_ID,
  INCOMPLETE_STATUS_ID,
  INITIATED_SCANNER_STATUS_ID,
  KIND_TRANSLATION,
  LINK_DOCUMENTATION_HIDE_ON_ACCEPT,
  LINK_DOCUMENTATION_HTML,
  LINK_DOCUMENTATION_TAG_MANAGER,
  LOGO_CUSTOMIZATION_CARD_ID,
  MOBILE_PREVIEW_HEIGHT,
  MOBILE_PREVIEW_WIDTH,
  NEW_BANNER_MODAL_CONTROL_ITEMS,
  POSITION_CUSTOMIZATION_CARD_ID,
  PREVIEW_MODES,
  PRIMARY_BANNER_ACTION_BUTTONS,
  PRIVACY_PORTAL_CUSTOMIZATION_CARD_ID,
  TEXT_CUSTOMIZATION_CARD_ID,
  TEXT_CUSTOMIZATION_LEVEL_2_CARD_ID,
  SCANNER_STATUS_COLOR,
  SCANNER_STATUS_ICON,
  SCANNER_STATUS_TRANSLATION,
  STATUS_CHIP_COLOR,
  STATUS_CHIP_FONT_COLOR,
  STATUS_TRANSLATION,
  STEPS,
  SUCCESS_MESSAGES,
  SUPPORTED_IMAGE_FILE_INPUT_TYPES,
  SUPPORTED_IMAGE_FILE_SCHEMA_TYPES,
}

export default banners
